import axios from 'axios';
const pub = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost/bootcamp/foundermind-backend/public',
  headers: { 'Content-Type': 'application/json' },
});

// Unwrap the backend envelope { success, data, message } transparently
pub.interceptors.response.use(
  (res) => {
    if (res.data && typeof res.data === 'object' && 'data' in res.data) {
      res.data = res.data.data;
    }
    return res;
  },
  (err) => Promise.reject(err)
);
export const getPublicAssessment = (token)              => pub.get(`/api/public/assessments/${token}`);
export const startSubmission     = (token, data)        => pub.post(`/api/public/assessments/${token}/start`, data);
export const saveAnswers         = (token, subId, data) => pub.put(`/api/public/assessments/${token}/save`, { submission_id: subId, ...data });
export const submitAssessment    = (token, subId, data) => pub.post(`/api/public/assessments/${token}/submit`, { submission_id: subId, ...data });
